document.addEventListener('DOMContentLoaded', () => {
  const quizContainers = document.querySelectorAll('.wp-block-giscon-quiz-block');

  quizContainers.forEach(container => {
    const quizId = container.dataset.quizId;
    if (!quizId) return;

    let quizData = null;
    let currentStep = -1; // -1: Start Page, 0 to N-1: Questions, N: Review/Submit, N+1: Results
    let userAnswers = {}; // { questionIndex: [selectedChoiceTexts] }
    let resultsData = null;

    // Initialize Quiz
    init();

    async function init() {
      renderLoading();
      try {
        const response = await fetch(`/wp-json/giscon-quiz/v1/quiz/${quizId}`);
        if (!response.ok) {
          throw new Error('Failed to load quiz');
        }
        quizData = await response.json();
        render();
      } catch (error) {
        renderError(error.message);
      }
    }

    function renderLoading() {
      container.innerHTML = `
        <div class="quiz-loader">
          <div class="quiz-spinner"></div>
          <p>Loading Quiz...</p>
        </div>
      `;
    }

    function renderError(message) {
      container.innerHTML = `
        <div style="padding: 24px; text-align: center; color: var(--quiz-error); border: 1px solid var(--quiz-error-light); background: var(--quiz-error-light); border-radius: 8px;">
          <strong>Error:</strong> ${message}
        </div>
      `;
    }

    function render() {
      if (!quizData) return;

      const totalQuestions = quizData.questions.length;

      // Handle Start Page (-1)
      if (currentStep === -1) {
        renderStartPage();
        return;
      }

      // Container skeleton
      container.innerHTML = `
        <div class="quiz-stepper">
          <div class="quiz-stepper-line">
            <div class="quiz-stepper-line-progress" id="stepper-progress"></div>
          </div>
          <!-- steps will be inserted here -->
        </div>
        <div class="quiz-step-content" id="quiz-step-content"></div>
      `;

      // Update stepper line progress bar
      const progressLine = container.querySelector('#stepper-progress');
      if (progressLine) {
        const progressPercentage = (currentStep / totalQuestions) * 100;
        progressLine.style.width = `${progressPercentage}%`;
      }

      // Render stepper nodes
      const stepper = container.querySelector('.quiz-stepper');
      for (let i = 0; i <= totalQuestions; i++) {
        const stepNode = document.createElement('div');
        stepNode.className = 'quiz-step';

        if (i < currentStep) {
          stepNode.classList.add('completed');
        } else if (i === currentStep) {
          stepNode.classList.add('active');
        }

        const isLast = i === totalQuestions;
        let bubbleText = '';
        let labelText = '';

        if (isLast) {
          bubbleText = `
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M20 6L9 17l-5-5"/>
            </svg>
          `;
          labelText = 'Review & Submit';
        } else {
          const percent = Math.round(((i + 1) / totalQuestions) * 100);
          bubbleText = `${percent}%`;
          labelText = `Question ${i + 1}`;
        }

        stepNode.innerHTML = `
          <div class="quiz-step-bubble">${bubbleText}</div>
          <div class="quiz-step-label">${labelText}</div>
        `;
        stepper.appendChild(stepNode);
      }

      // Render Content based on step
      const stepContent = container.querySelector('#quiz-step-content');
      if (currentStep < totalQuestions) {
        renderQuestion(currentStep, stepContent);
      } else if (currentStep === totalQuestions) {
        renderReview(stepContent);
      } else {
        renderResults(stepContent);
      }
    }

    function renderStartPage() {
      const totalQuestions = quizData.questions.length;
      container.innerHTML = `
        <div class="quiz-review-screen">
          <div class="quiz-review-icon">🎓</div>
          <h2 class="quiz-review-title">${escapeHtml(quizData.title)}</h2>
          ${quizData.description ? `<p class="quiz-review-text" style="margin-bottom: 24px;">${escapeHtml(quizData.description)}</p>` : ''}
          <div class="quiz-review-summary" style="margin-bottom: 32px;">
            <div class="quiz-review-item">
              <div class="quiz-review-badge"></div>
              <div>This quiz consists of <strong>${totalQuestions} questions</strong>.</div>
            </div>
            <div class="quiz-review-item">
              <div class="quiz-review-badge"></div>
              <div>Ensure you select at least one choice per question to move forward.</div>
            </div>
            <div class="quiz-review-item">
              <div class="quiz-review-badge"></div>
              <div>Note: There is no going back once you submit a response.</div>
            </div>
          </div>
          <div style="display: flex; justify-content: center;">
            <button class="quiz-btn quiz-btn-primary" id="quiz-start-btn">
              <span>Start Quiz</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
        </div>
      `;

      container.querySelector('#quiz-start-btn').addEventListener('click', () => {
        currentStep = 0;
        render();
      });
    }

    function renderQuestion(index, target) {
      const question = quizData.questions[index];
      const selected = userAnswers[index] || [];
      const isMultiple = question.question_type === 'Multiple Selection' || question.question_type === 'Multiple';

      target.innerHTML = `
        <div class="quiz-question-container">
          <h2 class="quiz-question-title">${question.question_text}</h2>
          <div class="quiz-choices-list"></div>
          <div class="quiz-actions">
            <button class="quiz-btn quiz-btn-primary" id="quiz-next-btn" disabled>
              <span>Next Question</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
        </div>
      `;

      const choicesList = target.querySelector('.quiz-choices-list');
      const nextBtn = target.querySelector('#quiz-next-btn');

      const updateButtonState = () => {
        const answers = userAnswers[index] || [];
        nextBtn.disabled = answers.length === 0;
      };

      question.choices.forEach(choice => {
        const choiceCard = document.createElement('div');
        choiceCard.className = 'quiz-choice-card';
        choiceCard.dataset.type = isMultiple ? 'multiple' : 'single';
        
        const isSelected = selected.includes(choice.choice_text);
        if (isSelected) {
          choiceCard.classList.add('selected');
        }

        choiceCard.innerHTML = `
          <div class="quiz-choice-left">
            <div class="quiz-choice-control"></div>
            <span class="quiz-choice-text">${escapeHtml(choice.choice_text)}</span>
          </div>
          <div class="quiz-choice-arrow">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        `;

        choiceCard.addEventListener('click', () => {
          let answers = userAnswers[index] || [];

          if (isMultiple) {
            if (answers.includes(choice.choice_text)) {
              answers = answers.filter(a => a !== choice.choice_text);
            } else {
              answers.push(choice.choice_text);
            }
          } else {
            answers = [choice.choice_text];
            choicesList.querySelectorAll('.quiz-choice-card').forEach(card => card.classList.remove('selected'));
          }

          userAnswers[index] = answers;

          if (answers.includes(choice.choice_text)) {
            choiceCard.classList.add('selected');
          } else {
            choiceCard.classList.remove('selected');
          }

          updateButtonState();
        });

        choicesList.appendChild(choiceCard);
      });

      updateButtonState();

      nextBtn.addEventListener('click', () => {
        currentStep++;
        render();
      });
    }

    function renderReview(target) {
      const itemsHtml = quizData.questions.map((q, idx) => `
        <div class="quiz-review-item">
          <div class="quiz-review-badge"></div>
          <div><strong>Question ${idx + 1}:</strong> Answered (${(userAnswers[idx] || []).length} options selected)</div>
        </div>
      `).join('');

      target.innerHTML = `
        <div class="quiz-review-screen">
          <div class="quiz-review-icon">📝</div>
          <h2 class="quiz-review-title">Ready to Submit?</h2>
          <p class="quiz-review-text">You have answered all questions. Review your progress summary below and submit your quiz for grading.</p>
          <div class="quiz-review-summary">
            ${itemsHtml}
          </div>
          <div style="display: flex; justify-content: center;">
            <button class="quiz-btn quiz-btn-primary" id="quiz-submit-btn">
              <span>Submit Quiz</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
          </div>
        </div>
      `;

      target.querySelector('#quiz-submit-btn').addEventListener('click', submitQuiz);
    }

    async function submitQuiz() {
      renderLoading();
      try {
        const answersPayload = Object.keys(userAnswers).map(qIdx => ({
          question_index: parseInt(qIdx),
          selected_choices: userAnswers[qIdx]
        }));

        const response = await fetch(`/wp-json/giscon-quiz/v1/quiz/${quizId}/submit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ answers: answersPayload })
        });

        if (!response.ok) {
          throw new Error('Submission failed');
        }

        resultsData = await response.json();
        currentStep++;
        render();
      } catch (error) {
        renderError(error.message);
      }
    }

    function renderResults(target) {
      const scorePercent = Math.round((resultsData.score / resultsData.total_questions) * 100);
      const circumference = 376.99;
      const offset = circumference - (scorePercent / 100) * circumference;

      let reviewCardsHtml = '';
      resultsData.results.forEach((res, idx) => {
        const questionObj = quizData.questions[idx];
        const userSelected = userAnswers[idx] || [];

        let choicesHtml = '';
        res.choices.forEach(choice => {
          const isSelected = userSelected.includes(choice.choice_text);
          const isCorrect = choice.correct_or_incorrect;

          let cardClass = '';
          if (isCorrect) {
            cardClass = isSelected ? 'correct' : 'correct-unselected';
          } else {
            cardClass = isSelected ? 'incorrect-selected' : '';
          }

          choicesHtml += `
            <div class="quiz-choice-card ${cardClass}" data-type="${questionObj.question_type === 'Multiple Selection' ? 'multiple' : 'single'}">
              <div class="quiz-choice-left">
                <div class="quiz-choice-control"></div>
                <span class="quiz-choice-text">${escapeHtml(choice.choice_text)}</span>
              </div>
              <div class="quiz-choice-arrow">
                ${isCorrect ? `
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--quiz-success)" stroke-width="3">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                ` : isSelected ? `
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--quiz-error)" stroke-width="3">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                ` : ''}
              </div>
            </div>
          `;
        });

        const statusLabel = res.is_correct ? 
          `<span style="color: var(--quiz-success); font-weight: 700;">✓ Correct</span>` : 
          `<span style="color: var(--quiz-error); font-weight: 700;">✗ Incorrect</span>`;

        reviewCardsHtml += `
          <div style="background-color: var(--quiz-bg-card); border: 1px solid var(--quiz-border); border-radius: 16px; padding: 24px; margin-bottom: 24px; box-shadow: var(--quiz-shadow);">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
              <span style="font-weight: 700; color: var(--quiz-text-muted);">Question ${idx + 1}</span>
              ${statusLabel}
            </div>
            <h3 style="font-size: 18px; font-weight: 700; margin-bottom: 20px;">${questionObj.question_text}</h3>
            <div class="quiz-choices-list" style="margin-bottom: 0;">
              ${choicesHtml}
            </div>
            ${res.explanation ? `
              <div class="quiz-explanation-box">
                <div class="quiz-explanation-title">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                  </svg>
                  <span>Explanation</span>
                </div>
                <div class="quiz-explanation-content">${res.explanation}</div>
              </div>
            ` : ''}
          </div>
        `;
      });

      target.innerHTML = `
        <div class="quiz-results-header">
          <div class="quiz-score-circle">
            <svg>
              <circle class="quiz-score-circle-bg" cx="70" cy="70" r="60"></circle>
              <circle class="quiz-score-circle-bar" cx="70" cy="70" r="60" style="stroke-dasharray: ${circumference}; stroke-dashoffset: ${offset};"></circle>
            </svg>
            <div class="quiz-score-text">${scorePercent}%</div>
          </div>
          <h2 class="quiz-results-title">Quiz Completed!</h2>
          <p class="quiz-results-feedback">You scored ${resultsData.score} out of ${resultsData.total_questions} questions correct.</p>
          <div style="display: flex; justify-content: center;">
            <button class="quiz-btn quiz-btn-primary" id="quiz-retake-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="transform: scaleX(-1);">
                <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"/>
              </svg>
              <span>Retake Quiz</span>
            </button>
          </div>
        </div>
        
        <h2 style="font-size: 22px; font-weight: 700; margin-bottom: 24px; text-align: center;">Review Your Answers</h2>
        <div class="quiz-results-review">
          ${reviewCardsHtml}
        </div>
      `;

      target.querySelector('#quiz-retake-btn').addEventListener('click', () => {
        currentStep = -1; // Go back to start screen
        userAnswers = {};
        resultsData = null;
        init();
      });
    }

    function escapeHtml(str) {
      if (typeof str !== 'string') return '';
      return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }
  });
});
